/** Zoom levels allowed above the fitBounds zoom (pinch / + button). */
export const FIT_ZOOM_IN = 3;

/** Zoom levels allowed below the fitBounds zoom. */
export const FIT_ZOOM_OUT = 1;

/**
 * Finite zoom band around a fitBounds zoom.
 * Without a TileLayer, Leaflet defaults maxZoom to Infinity — pinch then
 * blows ImageOverlay/SVG up until mobile WebKit OOMs.
 * @param {number} fitZoom Zoom after fitBounds
 * @param {number} [zoomIn]
 * @param {number} [zoomOut]
 * @returns {{ minZoom: number, maxZoom: number }}
 */
export const zoomLimitsFromFit = (
  fitZoom,
  zoomIn = FIT_ZOOM_IN,
  zoomOut = FIT_ZOOM_OUT
) => ({
  minZoom: fitZoom - zoomOut,
  maxZoom: fitZoom + zoomIn,
});

/**
 * fitBounds then clamp min/max zoom to a safe band around the fit zoom.
 * Temporarily widens limits so a previous clamp cannot block the new fit.
 * @param {import('leaflet').Map} map
 * @param {import('leaflet').LatLngBounds} bounds Image bounds (unpadded)
 * @param {number} [pad=0.125] maxBounds padding
 * @returns {import('leaflet').Map}
 */
export const fitBoundsAndClampZoom = (map, bounds, pad = 0.125) => {
  map.setMinZoom(-20);
  map.setMaxZoom(20);
  map.setMaxBounds(bounds.pad(pad)).fitBounds(bounds, { animate: false });
  const { minZoom, maxZoom } = zoomLimitsFromFit(map.getZoom());
  map.setMinZoom(minZoom);
  map.setMaxZoom(maxZoom);
  return map;
};
